(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('fc-slider');
  const slides = slider.querySelectorAll('.fc-slide');
  const dots = document.querySelectorAll('.fc-dot');

  // Scroll to the corresponding slide on dot click
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = dot.dataset.index;
      const targetSlide = slides[index];
      slider.scrollTo({
        left: targetSlide.offsetLeft - slider.offsetLeft,
        behavior: 'smooth'
      });
    });
  });

  // Highlight the active dot based on scroll position
  slider.addEventListener('scroll', () => {
    let center = slider.scrollLeft + slider.offsetWidth / 2;
    let closestIndex = 0;
    let minDistance = Infinity;

    slides.forEach((slide, i) => {
      let slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
      let distance = Math.abs(center - slideCenter);
      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = i;
      }
    });

    dots.forEach(dot => dot.classList.remove('active'));
    dots[closestIndex].classList.add('active');
  });

  // Initialize the first dot as active if slides exist
  if (dots.length) {
    dots[0].classList.add('active');
  }
});

  } catch(e) { console.error(e); }
})();
})();
